import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const [year, setYear] = useState(null);

    useEffect(() => {
        let date = new Date();
        setYear(date.getFullYear())
    }, [])

    return (
        <div className="text-center py-2" style={{ background: "#f8f9fa", borderTop: "1px solid #e9ecef" }}>
            <p style={{ fontSize: "0.8rem", color: "#6c757d" }} className="m-0 p-0">&copy; {year} The Sustainability Academy. All rights reserved - <Link to="/gdpr/privacy">Privacy policy</Link></p>
        </div>
    );
};

export default Footer;